import { render, staticRenderFns } from "./placement-todays.vue?vue&type=template&id=18c71678"
import script from "./placement-todays.vue?vue&type=script&lang=js"
export * from "./placement-todays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports